import { makeStyles } from "tss-react/mui";

interface IParams {
    priceColor?: string;
    priceFontSize?: string;
    descriptionFontSize?: string;
    direction: "row" | "column";
    alignItems?: "center" | "flex-end";
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    container: {
        display: "flex",
        flexDirection: props.direction,
        gap: props.direction === "row" ? theme.spacing(1) : 0,
        alignItems: props.direction === "row" ? "flex-end" : "center",
        justifyContent: "center",
    },
    price: {
        color: props.priceColor ?? theme.palette.primary.main,
        fontSize: props.priceFontSize ?? 42,
    },
    description: {
        fontSize: props.descriptionFontSize ?? 18,
        marginTop: props.direction === "row" ? 0 : -10,
        paddingBottom: props.direction === "row" ? 3 : 0,
        whiteSpace: "nowrap",
    },
}));
